/* eslint-disable */
import React, { useContext } from 'react';

// Custom Components
import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

// Models
import modelCestePutevi from '@/models/ceste_putevi';
import modelAktivnosti from '@/models/cesta_put_aktivnosti';

// Types
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import UserContext from '@/context/UserContext/UserContext';

type CestePuteviDataCentricPageParams = {};

const CestePuteviDataCentricPage = (
  props: CestePuteviDataCentricPageParams
) => { 
  const userContext = useContext(UserContext);
  const canEdit = userContext?.hasAnyPermission([Permissions.CestovnaInfrastrukturaEdit]);
  
  return (
    <AppPage
      titlett="cestovna_infrastruktura:page.ceste_putevi"
      needPermission={[Permissions.CestovnaInfrastruktura]}
    >
      <DataCentricPage
        primaryModel={modelCestePutevi}
        primaryTitleToken="titles.ceste_putevi"
        primaryView='default'
        secondaryModel={modelAktivnosti}
        secondaryTitleToken="titles.aktivnosti_odrzavanja"
        secondaryView='default'
        baseRecordPath={modelCestePutevi.apiPath}
        childRecordRelativePath="maintenance-activities"
        geomRelativePath=""
        mapId={51}
        mapModel={modelCestePutevi}
        primaryAllowView
        primaryAllowExportShape={true}
        primaryAllowExportDxf={true}
        secondaryAllowAdd={canEdit}
        secondaryAllowEdit={canEdit}
        secondaryAllowDelete={canEdit}
        foreignKeyField="path_id"
      />
    </AppPage>
  )}

export default CestePuteviDataCentricPage;
